import _ from 'lodash'
import { MiddlewareAPI, isRejectedWithValue } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { appIntl } from '../utils/IntlGlobalProvider'
import { logout } from '../features/user/userSlice'

export const rtkQueryErrorLogger =
    (api: MiddlewareAPI) => (next) => (action) => {
        if (isRejectedWithValue(action)) {
            _.map(action.payload?.data?.errors, (error) => {
                if (error.code !== 1003) {
                    // 1017 у course-service - «пән используется в курсе», у bff/iam - ACCESS_DENIED: различаем по message
                    const id = error.message === 'ACCESS_DENIED' ? 'errorAccessDenied' : error.code
                    const text = appIntl().formatMessage({ id, defaultMessage: error.message })
                    // field - что именно не прошло (правило, поле): без него «VALIDATION_ERROR» ничего не говорит
                    toast.error(
                        error.field ? `${text} (${error.field})` : text,
                        { autoClose: 5000 },
                    )
                }

                if (error.code === 1003) {
                    api.dispatch(logout())
                }
            })
        }

        return next(action)
    }
